import { Typography, TypographyProps } from "@mui/material"
import { PropsWithChildren } from "react"

type IProps = TypographyProps & {

}

const Text: React.FC<PropsWithChildren<IProps>> = (props) => {
  const { children, ...rest } = props;

  return <Typography {...rest}>{children}</Typography>
}

export default Text;
